/**
 * @flow
 * @relayHash b8cf5e6fd7ce67a8cab20c2f84132c7e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateUserContactEventInput = {
  clientMutationId?: ?string,
  user_contact_id: string,
  event_id: string,
  role: string,
};
export type NewContactDesktop_createUserContactEventMutationVariables = {|
  input: CreateUserContactEventInput
|};
export type NewContactDesktop_createUserContactEventMutationResponse = {|
  +createUserContactEvent: ?{|
    +new_event_user_contact_edge: ?{|
      +id: ?string,
      +role: ?string,
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_addresses: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +line1: ?string,
              +line2: ?string,
              +city: ?string,
              +province: ?string,
              +postal_code: ?string,
              +country: ?string,
            |}
          |}>
        |},
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +address: ?string,
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +number: ?string,
            |}
          |}>
        |},
      |},
    |}
  |}
|};
export type NewContactDesktop_createUserContactEventMutation = {|
  variables: NewContactDesktop_createUserContactEventMutationVariables,
  response: NewContactDesktop_createUserContactEventMutationResponse,
|};
*/


/*
mutation NewContactDesktop_createUserContactEventMutation(
  $input: CreateUserContactEventInput!
) {
  createUserContactEvent(input: $input) {
    new_event_user_contact_edge {
      id
      role
      node {
        id
        first_name
        last_name
        user_contact_addresses {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
            }
          }
        }
        user_contact_emails {
          edges {
            node {
              id
              label
              address
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              id
              label
              number
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserContactEventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createUserContactEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateUserContactEventInput!"
      }
    ],
    "concreteType": "CreateUserContactEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "new_event_user_contact_edge",
        "storageKey": null,
        "args": null,
        "concreteType": "EventUserContactEdge",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "role",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContact",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "first_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_addresses",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactAddressConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactAddress",
                        "plural": false,
                        "selections": [
                          v1,
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "country",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_emails",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmailConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactEmail",
                        "plural": false,
                        "selections": [
                          v1,
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "address",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_phones",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactPhoneConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactPhone",
                        "plural": false,
                        "selections": [
                          v1,
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "number",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "NewContactDesktop_createUserContactEventMutation",
  "id": null,
  "text": "mutation NewContactDesktop_createUserContactEventMutation(\n  $input: CreateUserContactEventInput!\n) {\n  createUserContactEvent(input: $input) {\n    new_event_user_contact_edge {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        user_contact_addresses {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n            }\n          }\n        }\n        user_contact_emails {\n          edges {\n            node {\n              id\n              label\n              address\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              id\n              label\n              number\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NewContactDesktop_createUserContactEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v3
  },
  "operation": {
    "kind": "Operation",
    "name": "NewContactDesktop_createUserContactEventMutation",
    "argumentDefinitions": v0,
    "selections": v3
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fb32fcd70010979fb62c1d7ae4e0c829';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/NewContactDesktop_createUserContactEventMutation.graphql.js